import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMultipleSelect({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;
    const { questionList } = questionData;

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [chunkedQuestionList, setChunkedQuestionList] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setSelectedOptions([]);
        const processChunkQuestionList = () => {
            if (questionList) {
                // Divide the questionList into chunks of up to 6 items each for multiple columns if needed
                let chunkList = [];
                for (let i = 0; i < questionList.length; i += 6) {
                    chunkList.push(questionList.slice(i, i + 6));
                    setChunkedQuestionList(chunkList);
                }
    
                chunkList[0] = makeArrayRandom(chunkList[0]);
                // set again the chunklist after arrayndom
                setChunkedQuestionList(chunkList);
            }
        }
        processChunkQuestionList();
    }, [question, 
        questionList
    ]);

    const handleSelect = (option) => {
        setSelectedOptions((prev) => {
            const newSelectedOptions = prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option];

            // we will enabled the next button if can proceed
            const canProceed = newSelectedOptions.length > 0
            onAnswer({
                canProceed,
                answer: newSelectedOptions,
            });

            return newSelectedOptions;
        });
    };

    const buttonWidth = questionList && questionList.length > 6 ? "150px" : "400px";
    const buttonHeight = questionList && questionList.length > 6 ? "60px" : "80px";

    return (
        <Box
            sx={{
                display: "flex",
                padding: "20px",
                backgroundColor: "white",
                justifyContent: "center",
                flexWrap: {
                    xs: "wrap",
                    sm: "nowrap",
                },
            }}
        >
            <Box
                sx={{
                    flexShrink: 1,
                    marginRight: "20px",
                    maxWidth: "600px",
                    minWidth: "300px",
                    alignContent: "center",
                }}
            >
                <Box
                    component="img"
                    src={`${imagesResources}${data.image}`}
                    style={{
                        height: "auto",
                        width: "600px",
                        borderRadius: "4px",
                    }}
                    alt="Img"
                />
            </Box>

            <Box
                sx={{
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}
            >
                {chunkedQuestionList.map((chunk, chunkIndex) => (
                    <Box
                        key={chunkIndex}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight:
                                chunkIndex !== chunkedQuestionList.length - 1
                                    ? "20px"
                                    : "0",
                        }}
                    >
                        {chunk.map((option, index) => (
                            <Button
                                key={index}
                                variant="contained"
                                onClick={() => handleSelect(option)}
                                sx={{
                                    marginBottom: "10px",
                                    width: buttonWidth,
                                    height: buttonHeight,
                                    cursor: "pointer",
                                    userSelect: "none",
                                    color: "black",
                                    backgroundColor: selectedOptions.includes(
                                        option
                                    )
                                        ? "rgb(175, 226, 62)"
                                        : "rgb(218, 218, 218)",
                                    borderBottom: `10px solid ${
                                        selectedOptions.includes(option)
                                            ? "rgb(99, 151, 41)"
                                            : "rgb(128, 128, 128)"
                                    }`,
                                    fontWeight: "bold",
                                    "&.MuiButton-contained": {
                                        backgroundColor:
                                            selectedOptions.includes(option)
                                                ? "rgb(175, 226, 62)"
                                                : "rgb(218, 218, 218)",
                                        boxShadow: "none",
                                    },
                                    "&:hover.MuiButton-contained": {
                                        backgroundColor:
                                            selectedOptions.includes(option)
                                                ? "rgb(175, 226, 62)"
                                                : "rgb(218, 218, 218)",
                                        boxShadow: "none",
                                    },
                                    fontSize: "1.2rem",
                                }}
                            >
                                {option}
                            </Button>
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
